import HttpRequest from '@/utils/axios'
const axios = new HttpRequest()
export default axios
